import React, { useState } from "react";
import { faBriefcase, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Card from "../common/card";

import "./styles/works.css";

const experiences = [
	{
		initials: "MD",
		title: "The Mindset Development Institute",
		role: "Founder",
		duration: "Since 2019",
		description:
			"Developed 40+ mindset models for critical thinking in leadership, relationships, communication and DEIB.",
		link: "https://mindsetdevelopmentinstitute.com/",
	},
	{
		initials: "SX",
		title: "Sewells MSX International",
		role: "Associate Partner, Facilitator",
		duration: "Since 2021",
		description:
			"Facilitates leadership, emotional intelligence, effective communication and conflict resolution programmes.",
		link: "https://www.msxi.com/",
	},
	{
		initials: "PT",
		title: "Preferental Technologies",
		role: "Non-Executive Director",
		duration: "Board Member",
		description:
			"Board member of a multi-platform property tech group of companies.",
		link: "https://www.preferental.com",
	},
	{
		initials: "PS",
		title: "Professional Speakers Association of Southern Africa",
		role: "Vice-President, EXCO Member",
		duration: "2023 - 2024 term · Member since 2020",
		description:
			"Served as VP for the 2023-2024 term; EXCO member and professional member since 2020.",
		link: "https://www.psasouthernafrica.co.za",
	},
	{
		initials: "SM",
		title: "Success Mindset Summit",
		role: "Founder",
		duration: "",
		description:
			"Hosts multicultural events including women and young people in Fintech, Proptech and Professional Speaking.",
		link: null,
	},
	{
		initials: "MC",
		title: "Men Of Change Movement",
		role: "Founder",
		duration: "",
		description:
			"Addresses issues affecting men through events, mentorship and the Men Of Change Podcast.",
		link: "https://www.youtube.com/@MenOfChange-g9j",
	},
	{
		initials: "GA",
		title: "GIBS Alumni Speakers Association",
		role: "Executive Member",
		duration: "",
		description: "Executive member supporting alumni speaker engagements.",
		link: null,
	},
	{
		initials: "IX",
		title: "INX Prime TV",
		role: "Presenter, Monday Motivation",
		duration: "DSTV Channel 345",
		description: "Presents Monday Motivation TV on the INX Prime TV channel.",
		link: null,
	},
];

const INITIAL_VISIBLE_COUNT = 3;

const Works = () => {
	const [showAll, setShowAll] = useState(false);

	const visibleExperiences = showAll
		? experiences
		: experiences.slice(0, INITIAL_VISIBLE_COUNT);

	const hasMore = experiences.length > INITIAL_VISIBLE_COUNT;
	const hiddenCount = experiences.length - INITIAL_VISIBLE_COUNT;

	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body-wrapper">
						<div className="works-body">
							{visibleExperiences.map((exp, index) => (
								<div
									className={`work-card${
										index >= INITIAL_VISIBLE_COUNT ? " work-card-enter" : ""
									}`}
									key={exp.title}
									style={
										index >= INITIAL_VISIBLE_COUNT
											? { animationDelay: `${(index - INITIAL_VISIBLE_COUNT) * 70}ms` }
											: undefined
									}
								>
									<div className="work-card-header">
										<div className="work-avatar">{exp.initials}</div>
										<div className="work-heading">
											<div className="work-title">{exp.title}</div>
											<div className="work-role">{exp.role}</div>
											{exp.duration && (
												<div className="work-duration">{exp.duration}</div>
											)}
										</div>
									</div>
									<p className="work-description">{exp.description}</p>
									{exp.link && (
										<a
											href={exp.link}
											target="_blank"
											rel="noopener noreferrer"
											className="work-link"
										>
											Visit site
										</a>
									)}
								</div>
							))}
						</div>
						{hasMore && (
							<button
								type="button"
								className="works-toggle-btn"
								onClick={() => setShowAll((prev) => !prev)}
							>
								<span>
									{showAll ? "View less" : `View ${hiddenCount} more`}
								</span>
								<FontAwesomeIcon
									icon={faChevronDown}
									className={`works-toggle-icon${showAll ? " rotated" : ""}`}
								/>
							</button>
						)}
					</div>
				}
			/>
		</div>
	);
};

export default Works;